<template>
    <div>
        <van-sticky>
            <van-cell title="选择日期区间" :value="date" @click="show = true"/>
            <van-calendar :default-date="currentDate" v-model="show" type="range" @confirm="onConfirm"
                          :min-date="minDate" :max-date="maxDate"/>
        </van-sticky>
        <div style="padding-bottom: 60px">

            <table class="mobileTable">
                <thead>
                <tr>
                    <th>姓名</th>
                    <th>添加</th>
                    <th>素材</th>
                    <th>跟进</th>
                    <th>未知行业</th>
                    <th>未跟进</th>
                    <th>需求确认</th>
                    <th>未演示、试用中</th>
                    <th>已演示、试用中</th>
                    <th>已演示、未试用</th>
                    <th>已成交</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in WXCPUserReport.StdQuery" :class="index%2==0?'stripe':''">
                    <td>
                        {{ item.ChargeDay }}{{ item.CPName }}
                    </td>
                    <td @click="goToList(item,'Report_Add')" :class="item.FollowUser>0?'link':''">
                        {{ item.FollowUser }}
                    </td>
                    <td @click="goToList(item,'Report_Resource')" :class="item.ResourceUser>0?'link':''">
                        {{ item.ResourceUser }}
                    </td>
                    <td @click="goToList(item,'Report_Memo')" :class="item.FollowMemoUser>0?'link':''">
                        {{ item.FollowMemoUser }}
                    </td>
                    <td @click="goToListStatus(item,50)" :class="item.Status50>0?'link':''">{{ item.Status50 }}</td>
                    <td @click="goToListStatus(item,100)" :class="item.Status100>0?'link':''">{{ item.Status100 }}</td>
                    <td @click="goToListStatus(item,200)" :class="item.Status200>0?'link':''">{{ item.Status200 }}</td>
                    <td @click="goToListStatus(item,300)" :class="item.Status300>0?'link':''">{{ item.Status300 }}</td>
                    <td @click="goToListStatus(item,400)" :class="item.Status400>0?'link':''">{{ item.Status400 }}</td>
                    <td @click="goToListStatus(item,500)" :class="item.Status500>0?'link':''">{{ item.Status500 }}</td>
                    <td @click="goToListStatus(item,600)" :class="item.Status600>0?'link':''">{{ item.Status600 }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <van-tabbar route>
            <van-tabbar-item replace to="/work" icon="home-o">工作台</van-tabbar-item>
            <van-tabbar-item replace to="/report" icon="chart-trending-o">报表</van-tabbar-item>
            <van-tabbar-item replace to="/manager" icon="apps-o">管理</van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            date: '',
            currentDate: [this.dayjs().add(-7, 'day').toDate(), new Date()],
            show: false,
            minDate: this.dayjs().add(-5, 'year').toDate(),
            maxDate: new Date(),
            WXCPUserReport: {
                StdQuery: []
            }
        }
    },
    created() {
        this.date = `${this.formatDate(this.currentDate[0])} 至 ${this.formatDate(this.currentDate[1])}`;
        this.get_data()
    },
    methods: {
        goToListStatus(item, status) {
            this.$router.push({
                path: "/report/list",
                query: {
                    Date: item.OrigChargeDay,
                    Type: "Report_Status",
                    RelUserId: item.UserId,
                    Status: status
                }
            });
        },
        goToList(item, type) {
            this.$router.push({
                path: "/report/list",
                query: {
                    Date: item.OrigChargeDay,
                    Type: type,
                    RelUserId: item.UserId
                }
            });
        },
        formatDate(date) {
            return `${date.getMonth() + 1}-${date.getDate()}`;
        },
        onConfirm(date) {
            const [start, end] = date;
            this.show = false;
            this.date = `${this.formatDate(start)} 至 ${this.formatDate(end)}`;
            this.get_data()
        },
        async get_data() {
            this.WXCPUserReport = await this.$frame.getStdQueryData("WXCPUserReport", {
                BegDate: this.dayjs(this.currentDate[0]).format('YYYY-MM-DD'),
                EndDate: this.dayjs(this.currentDate[1]).format('YYYY-MM-DD'),
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.link {
  color: #1989fa !important;
  text-decoration-line: underline;
  text-underline-offset: 3px;
  text-decoration-color: #1989fa;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
}
</style>
